export const questionColumnsConfig = {
  ID:"id",
    CATEGORYID: "Category Name",
    QUESTION: "Question",
    TYPE: "Type", // ✅ Added label for action column
    OPTIONS: "Options",
    CORRECTANSWERL:"Correct Answer",
    ACTIONS: "Actions", // ✅ Added label for action column
  messages: "Are you sure you want to delete this question?" // Optional: for ConfirmPopup

  };
  